module.exports = __webpack_public_path__ + "static/media/GA.17a59f61.svg";